import React from 'react';
import { motion } from 'framer-motion';

function NotificationBanner({ isAnimated, setIsAnimated, children }) {
    const translateY = isAnimated ? '100%' : '0%';
    const animateOpacity = isAnimated ? '100%' : '0%';
    return (
        <motion.div
            onAnimationComplete={() => setIsAnimated(false)}
            className='notification'
            transition={{
                type: 'spring',
                stiffness: isAnimated ? 300 : 600,
                damping: isAnimated ? 70 : 40,
                y: {
                    duration: 0.7,
                },
                opacity: {
                    duration: 0.5,
                },
            }}
            animate={{
                x: '-50%',
                y: translateY,
                opacity: animateOpacity,
            }}>
            {children}
        </motion.div>
    );
}

export default NotificationBanner;
